import { DatepickerWrapper } from 'components/DatepickerWrapper';
import { DatepickerProvider } from 'hooks/useDatepickerContext';

import type { DatepickerProps } from './types';

export const Datepicker = ({
  mode,
  required = false,
  format = undefined,
  minDate = undefined,
  maxDate = undefined,
  onOpenChange = undefined,
  value = undefined,
  onChange,
  open = undefined,
  setOpen = undefined,
  disabled = false,
  readOnly = false,
  onClear = undefined,
  onBlur = undefined,
  children,
  placeholder = '',
  ...props
}: DatepickerProps) => {
  return (
    <DatepickerProvider
      mode={mode}
      required={required}
      value={value}
      onChange={onChange}
      controlledOpen={open}
      controlledSetOpen={setOpen}
      controlledOnOpenChange={onOpenChange}
      controlledFormat={format}
      controlledMinDate={minDate}
      controlledMaxDate={maxDate}
      disabled={disabled}
      readOnly={readOnly}
      onClear={onClear}
      onBlur={onBlur}
      placeholder={placeholder}
      {...{ 'data-testid': props['data-testid'] }}
    >
      <DatepickerWrapper required={required}>{children}</DatepickerWrapper>
    </DatepickerProvider>
  );
};
